import { z } from "zod";
import {
	KPI_METRIC_KEYS_LIST,
	TOUCHPOINT_OPTIONS,
} from "./constants.ts";

export const granularityValues = [
	"none",
	"daily",
	"weekly",
	"monthly",
] as const;

export const granularitySchema = z.enum(granularityValues);

const channelValues = TOUCHPOINT_OPTIONS.map((option) => option.value) as [
	string,
	...string[],
];

export const channelSchema = z.enum(channelValues);

const metricValues = [...KPI_METRIC_KEYS_LIST] as [string, ...string[]];

export const metricsSchema = z.enum(metricValues);

export const breakdownSchema = z.enum([
	"campaign",
	"adset",
	"ad",
	"keyword",
	"asset_group",
	"creative",
	"advertising_channel_type",
]);

export type AnalyticsGranularity = z.infer<typeof granularitySchema>;
